import PropTypes from 'prop-types';
import { Box, Card, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../../../components/Iconify';

export default function MetricCard({ title, value, caption, icon, color = 'primary', empty = false }) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2.5,
        bgcolor: empty ? 'background.neutral' : 'background.paper',
      }}
    >
      <Stack spacing={1.5} sx={{ p: 2.25, height: '100%' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="overline" color="text.secondary">
            {title}
          </Typography>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.75,
              display: 'grid',
              placeItems: 'center',
              color: (theme) => {
                const paletteColor = theme.palette[color];
                return paletteColor?.main || theme.palette.text.primary;
              },
              bgcolor: (theme) => {
                const paletteColor = theme.palette[color];
                return alpha(paletteColor?.main || theme.palette.grey[700], 0.12);
              },
            }}
          >
            <Iconify icon={icon} width={18} height={18} />
          </Box>
        </Stack>
        <Typography variant="h6" sx={{ lineHeight: 1.15 }}>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {caption}
        </Typography>
      </Stack>
    </Card>
  );
}

MetricCard.propTypes = {
  caption: PropTypes.string.isRequired,
  color: PropTypes.string,
  empty: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
